import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputFileCustom,
  InputTextArea,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
  TYPE_INSTANCE3,
  valueTipePembayaran,
} from "App/constants";

import { useSelectOption } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { RESET_STATE_SERVICE_TUTUP_TAGIHAN } from "./helpers";

function FormServiceTutupTagihan({
  formData,
  setFormData,
  file,
  setFile,
  setRowsListTagihan,
}) {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const newFormData = new FormData();
      newFormData.append("date", formData.date);
      newFormData.append("kas_id", formData.kas_id);
      newFormData.append("keterangan", formData.keterangan);
      newFormData.append("file", file);
      newFormData.append("tipe_pembayaran_id", formData.tipe_pembayaran_id);

      const response = await instance3.post(
        "/servpemb_tagihan/register",
        newFormData
      );
      if (response.data.status === 200) {
        setRowsListTagihan(response.data.data);
        setFormData({
          ...formData,
          id: response.data.id,
        });
        defaultToastSuccess(response.data.message);
      } else {
        defaultToastError(response.data.message);
      }
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error.response?.data?.message);
    }
  };

  const kasBank = useSelectOption(
    true,
    "/kas/kas/list",
    TYPE_INSTANCE3,
    "id",
    "nama"
  );

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Grid container>
        <Grid item sm={12}>
          <InputTextMaster
            name='id'
            label='ID'
            id='id'
            value={formData.id}
            onChange={handleChange("id")}
            placeholder='ID'
            disabled={true}
          />
        </Grid>
        <Grid item sm={12}>
          <InputTextMaster
            name='date'
            label='TANGGAL'
            id='date'
            value={formData.date}
            onChange={handleChange("date")}
            placeholder='ID'
            type='date'
          />
        </Grid>
        <Grid item sm={12}>
          <InputOptionMaster
            name='tipe_pembayaran_id'
            label='TIPE PEMBAYARAN'
            id='tipe_pembayaran_id'
            withSearch={false}
            data={valueTipePembayaran}
            value={formData.tipe_pembayaran_id}
            onChange={handleChange("tipe_pembayaran_id")}
          />
        </Grid>
        <Grid item sm={12}>
          <InputOptionMaster
            name='kas_id'
            label='KAS'
            id='kas_id'
            withSearch={true}
            data={kasBank}
            value={formData.kas_id}
            labelValue={formData.kas_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kas_id: null,
                  kas_name: "Pilih Kas",
                });
              } else {
                setFormData({
                  ...formData,
                  kas_id: e.value,
                  kas_name: e.label,
                });
              }
            }}
          />
        </Grid>

        <Grid item sm={12}>
          <InputTextArea
            label={"KETERANGAN"}
            placeholder={"Keterangan"}
            name='keterangan'
            value={formData.keterangan}
            onChange={handleChange("keterangan")}
            id='keterangan'
            rows={"3"}
          />
        </Grid>

        <Grid item sm={12}>
          <div>
            <label
              htmlFor='file-service-tutup-tagihan'
              style={{
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}>
              Pilih File
            </label>
            <InputFileCustom
              convertToBase64={false}
              label={"Upload File"}
              name={"file-service-tutup-tagihan"}
              id={"file-service-tutup-tagihan"}
              initialNameFile={file}
              setFile={setFile}
            />
          </div>
        </Grid>
      </Grid>

      <div>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            outline={true}
            type={"button"}
            color='danger'
            onClick={() => {
              setFormData(RESET_STATE_SERVICE_TUTUP_TAGIHAN);
              setFile(null);
              setRowsListTagihan([]);
            }}
            name='Reset'
            size='md'
          />
          <MasterButton
            outline={false}
            type={"submit"}
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </div>
    </form>
  );
}

export default FormServiceTutupTagihan;
